import React, { useRef, useState, useEffect } from "react";
import "./style.css";
import PrintIcon from "@mui/icons-material/Print";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Autocomplete, TextField } from "@mui/material";
import {
  APISTATUS,
  actionKeyName,
  listKotOrderStatus,
  orderStatus,
} from "../../utils/kotEnum";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedKOTOrder } from "../../kitchenOrderTicketSlice";
import { kotOrderActionAPI, updateSingleProductStatus } from "../../kotAPI's";
import { getAllActiveEmployeesAPICall } from "../../../../../API/Staff/HRM/employeeAPI";
import OfferTagIconSvg from "../icons/OfferTagIconSvg";
import { useReactToPrint } from "../../../../Shared/print/useHtml2PdfPrint";
import KotPrint from "../print/KotPrint";
import { setSubmitLoading } from "../../../../../Redux/Dashboard/mainDashBoardSlice";
import { kotPrintRequestAPICall, printRequestAPICall } from "../../../Settings/Device Settings/deviceSettingsAPI";
import  html2pdf  from "html2pdf.js";
import { pdfBlobOptionsPrint } from "../../../../Single Components/GneralUtilities";
import { getPPI } from "../../../../../Js/generalFunctions";
import { setBillLoading } from "../../../Sales/Billing/Slice/billingScreenSlice";
import { getCurrentTime, today } from "../../../../../Js/Date";
import Lottie from "react-lottie";
import FoodDriverCantFindurLocAnimation from "../../../../../lottie/FoodDriverCantFindurLoc.json";
const KotCard = ({
  elementData,
  day,
  orderNo,
  tableNo,
  name,
  // tokenNo,
  orderInfo,
  status,
}) => {
  const componentRef = useRef();

  const isExternalOnlineOrder = elementData?.isExternalOnlineOrder === true;

  const externalOnlineLottieOptions = {
    loop: true,
    autoplay: true,
    animationData: FoodDriverCantFindurLocAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const dispatch = useDispatch();
  const [deliveryBoyDialogOpen, setDeliveryBoyDialogOpen] = useState(false);
  const [selectedDeliveryBoy, setSelectedDeliveryBoy] = useState(null);
  
  // Get active employees list for delivery boy selection from global Redux store
  const allActiveEmpList = useSelector((state) => state.allActiveEmployeeSlice?.value);
  
  // Load saved delivery boy from localStorage and fetch employees on mount
  useEffect(() => {
    // Fetch active employees list if not already loaded
    if (!allActiveEmpList || allActiveEmpList.length === 0) {
      getAllActiveEmployeesAPICall();
    }
    
    // Load saved delivery boy from localStorage
    const savedDeliveryBoy = localStorage.getItem('ecommerce_delivery_boy');
    if (savedDeliveryBoy) {
      try {
        const parsedDeliveryBoy = JSON.parse(savedDeliveryBoy);
        setSelectedDeliveryBoy(parsedDeliveryBoy);
      } catch (e) {
        console.error('Failed to parse saved delivery boy:', e);
      }
    }
  }, []);
  
  const handleHeaderBtnChange = (key) => {
    // For ecommerce orders, show delivery boy selection dialog before marking as ready to pickup
    if (key === actionKeyName.DELIVERY && isExternalOnlineOrder && status === listKotOrderStatus.COMPLETED) {
      setDeliveryBoyDialogOpen(true);
      return;
    }
    
    dispatch(setSelectedKOTOrder({ ...elementData, actionKeyName: key }));
    const body = {
      actionKeyName: key,
      body: { id: elementData._id },
      postDate:`${today} ${getCurrentTime()}`,
    };
    kotOrderActionAPI(body);
  };
  
  const handleDeliveryBoyConfirm = () => {
    // Save selected delivery boy to localStorage for future use
    if (selectedDeliveryBoy) {
      localStorage.setItem('ecommerce_delivery_boy', JSON.stringify(selectedDeliveryBoy));
    }
    
    dispatch(setSelectedKOTOrder({ ...elementData, actionKeyName: actionKeyName.DELIVERY }));
    const body = {
      actionKeyName: actionKeyName.DELIVERY,
      body: { 
        id: elementData._id,
        deliveryBoyId: selectedDeliveryBoy?._id || null,
        deliveryBoyName: selectedDeliveryBoy?.staff_name || null
      },
      postDate:`${today} ${getCurrentTime()}`,
    };
    kotOrderActionAPI(body);
    setDeliveryBoyDialogOpen(false);
    // Don't reset selectedDeliveryBoy - keep it for next time
  };

  const { kotOrderStatus, darkMode } = useSelector(
    (state) => state.kitchenOrderTicketSlice
  );

  //print btn action
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const kotPrintClick=async()=>{
    try {
        let printSettingsString=localStorage.getItem('PrinterSettings')
        let printSettings=JSON.parse(printSettingsString)
        
        let payload={
          printerWidth: printSettings?.kotSize==="80"?48:32,
          printerName: printSettings?.kotPrinter,
          enableNativeName: printSettings?.enableKotNativeName || false,
          transNo: elementData?.name ,
          // transNo: tokenNo ,
          ordName: orderNo,
          orderDate:day,
          ordType:elementData?.ordType,
          waiterName: elementData?.waiterName || "-NIL-",
          orderInfo:orderInfo,
          tables:elementData?.tables,
          floorName:elementData?.floorName
      }
    if (printSettings?.kotPrinter) {
        kotPrintRequestAPICall(payload,handlePrint)
        }
        else{
          handlePrint()
        }
    } catch (error) {
        dispatch(setBillLoading(false))
    } finally {
      dispatch(setBillLoading(false));
    }
    
  }
  // single product selection
  const handleSingleProductClick = (data) => {
    if (kotOrderStatus.index === 2) {
      updateSingleProductStatus({
        body: {
          id: elementData._id,
          ordInfoId: data._id,
          statusType: data.status === APISTATUS.PENDING ? true : false,
        },
      });
    }
  };

  return (
    <div className={`kot-card-wrapper${isExternalOnlineOrder ? ' kot-card-wrapper-external-online' : ''}`}>
      <div className="kot-card-container">
        <div className="kot-card-header">
          <p className="card-order-no">Order No : {orderNo}</p>
          {
            elementData?.ordType==="DELIVERY"?
            <p className="card-table-no">Delivery: {elementData?.aggregatorName?.toUpperCase()}</p>
            :<p className="card-table-no">Table No : {tableNo.join(",")}</p>

          }
          <p className="card-date">{day}</p>
          <p className="card-token-no" style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "8px" }}>
            <span>Token No : {elementData?.name}</span>
            {isExternalOnlineOrder && (
              <span style={{ display: "inline-flex", alignItems: "center" }}>
                <Lottie options={externalOnlineLottieOptions} height={26} width={26} />
              </span>
            )}
          </p>
          {/* <p className="card-token-no">Token No : {tokenNo}</p> */}
          <p className="card-type">
            TYPE : <span>{elementData?.ordType}</span>
          </p>
        </div>
        <div className="card-print-container">
          <div>
            <span>waiter :</span> <span>{elementData?.waiterName}</span>
          </div>
          <div>
            <button onClick={kotPrintClick} className="card-print-btn">
              <PrintIcon fontSize="small" />
            </button>
          </div>
        </div>
        <div className="card-order-list-container">
          <ul>
            {orderInfo?.map((res, i) => (
              <li key={i} onClick={() => handleSingleProductClick(res)}>
                <div className="card-order-list">
                  {res.status === APISTATUS.COMPLETED &&
                    kotOrderStatus.index === 2 && (
                      <div
                        className="cross-line"
                        style={{
                          backgroundColor: darkMode ? "#ffffff" : "#000000",
                        }}
                      ></div>
                    )}
                  <div className="card-order-item-name">
                    {res.itemType === 3 && <OfferTagIconSvg />}
                    <span style={{ color: res.itemType === 3 ? "red" : "" }}>
                      {res?.productName}
                    </span>
                  </div>
                  <div className="card-order-quantity">
                    <span style={{ color: res.itemType === 3 ? "red" : "" }}>
                      {res?.qty}
                    </span>
                  </div>
                </div>
                {res?.customerNote && (
                  <div className="card-notes">
                    <p>Note : {res?.customerNote}</p>
                  </div>
                )}
                {/* combo offer  */}
                {res?.productList?.length > 0 && (
                  <ul className="kot-compo-offer-container">
                    {res?.productList?.map((res, i) => (
                      <li key={i}>
                        {res?.qty} X {res?.productName}
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </div>
        <div className="card-btn-container">
          {status === listKotOrderStatus.NEW && (
            <button
              onClick={() => handleHeaderBtnChange(actionKeyName.TOCOOK)}
              className={orderStatus.TOCOOK}
            >
              <span>To Cook</span>
            </button>
          )}
          {/* {status === listKotOrderStatus.NEW && ( 
            <button
              onClick={() => handleHeaderBtnChange(actionKeyName.REJECT)}
              className={orderStatus.REJECT}
            >
              <span>Reject</span>
            </button>
          )} */}
          {status === listKotOrderStatus.PREPARING && (
            <button
              onClick={() => handleHeaderBtnChange(actionKeyName.COMPLETED)}
              className={orderStatus.COMPLETE}
            >
              <span>Completed</span>
            </button>
          )}
          {status === listKotOrderStatus.COMPLETED && (
            <button
              onClick={() => handleHeaderBtnChange(actionKeyName.DELIVERY)}
              className={elementData?.ordType==="DELIVERY"?orderStatus.PICKUP:orderStatus.DELIVERY}
            >
              <span>
              {
                elementData?.ordType==="DELIVERY"?"Ready to pickup":"Delivery"
              }
              </span>
            </button>
          )}
          {status === listKotOrderStatus.COMPLETED && (
            <button
              onClick={() => handleHeaderBtnChange(actionKeyName.RESET)}
              className={orderStatus.RESET}
            >
              <span>Reset</span>
            </button>
          )}
          {/* Mark as Delivered button - only for ecommerce orders after Ready to Pickup */}
          {status === listKotOrderStatus.RDYPICKUP && isExternalOnlineOrder && (
            <button
              onClick={() => handleHeaderBtnChange(actionKeyName.ECOMMERCE_DELIVERED)}
              className={orderStatus.ECOMMERCE_DELIVERED}
            >
              <span>Mark as Delivered</span>
            </button>
          )}
        </div>

        <div className='print-parent'>
          <div ref={componentRef}>
            <KotPrint
              billNo={orderNo}
              waiter={elementData?.waiterName}
              orderDate={day}
              orderData={orderInfo}
              orderType={elementData?.ordType}
              tokenNumber={elementData?.name}
              // tokenNumber={tokenNo}
              kotPrintNotes={JSON.parse(localStorage.getItem('PrinterSettings') || '{}')?.kotPrintNotes || false}
            />
          </div>
        </div>
      </div>
      
      {/* Delivery Boy Selection Dialog for Ecommerce Orders */}
      <Dialog 
        open={deliveryBoyDialogOpen} 
        onClose={() => setDeliveryBoyDialogOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Select Delivery Boy</DialogTitle>
        <DialogContent>
          <Autocomplete
            options={allActiveEmpList || []}
            getOptionLabel={(option) => option?.staff_name || ""}
            value={selectedDeliveryBoy}
            onChange={(e, newValue) => setSelectedDeliveryBoy(newValue)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Delivery Boy"
                placeholder="Select delivery boy (optional)"
                variant="outlined"
                sx={{ mt: 2 }}
              />
            )}
            isOptionEqualToValue={(option, value) => option?._id === value?._id}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeliveryBoyDialogOpen(false)}>Cancel</Button>
          <Button 
            onClick={handleDeliveryBoyConfirm}
            variant="contained"
            color="primary"
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default KotCard;
